import { useMemo, type CSSProperties } from "react";
import { range, rand, pick } from "../utils/random";
import type { EffectProps } from "./types";

const HEARTS = ["♥", "♡", "❤", "💖", "💕"];
const COLORS = ["#ff5a8a", "#ff85a1", "#ff3e6c", "#ffb3c1", "#d62a55"];

export function FallingHearts({ count = 45 }: EffectProps = {}) {
  const hearts = useMemo(
    () =>
      range(count).map(i => ({
        id: i,
        char: pick(HEARTS),
        color: pick(COLORS),
        left: `${rand(0, 100)}vw`,
        size: `${rand(16, 36)}px`,
        fallDuration: `${rand(6, 12)}s`,
        delay: `${rand(-12, 0)}s`,
        opacity: rand(0.55, 0.95),
      })),
    [count],
  );

  return (
    <div className="fx-layer" aria-hidden>
      {hearts.map(h => (
        <span
          key={h.id}
          className="fx-particle fx-heart"
          style={
            {
              left: h.left,
              top: 0,
              fontSize: h.size,
              color: h.color,
              opacity: h.opacity,
              animationDuration: h.fallDuration,
              animationDelay: h.delay,
            } as CSSProperties
          }
        >
          {h.char}
        </span>
      ))}
    </div>
  );
}
